// Our Components
import Dropdown from 'components/Dropdown/Dropdown';

function LoanApplicationDropdown({
	selected,
	onChange,
	loanApplications,
	label,
	helperText
}) {
	if (!loanApplications) return null;

	return (
		<Dropdown
			label={label}
			helperText={helperText}
			items={loanApplications}
			selected={selected}
			onChange={onChange}
		/>
	);
}

LoanApplicationDropdown.defaultProps = {
	label: 'Optionally select a loan application',
	helperText: 'This allows you to resume a loan application'
};

export default LoanApplicationDropdown;
